import script from "./PrestVariantPierreVacance.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrestVariantPierreVacance.vue?vue&type=script&lang=ts&setup=true"

import "./PrestVariantPierreVacance.vue?vue&type=style&index=0&id=70a6833c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a6833c"]])

export default __exports__